"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _List = require("./List");

var _userProfile = require("user-profile");

var _decorators = require("decorators");

var _AccountList = babelHelpers.interopRequireDefault(require("./AccountList"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var VideoProcessedListItem = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(VideoProcessedListItem, _Component);

  function VideoProcessedListItem() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, VideoProcessedListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(VideoProcessedListItem)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "item", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "onSelected", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "asLink", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(VideoProcessedListItem, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_List.NotificationItem, {
        asLink: this.asLink,
        onSelected: this.onSelected,
        item: this.item,
        overlayType: "info",
        overlay: "check"
      }, "Your video on ", _react.default.createElement("span", {
        className: "courseActivity"
      }, this.item.activity.title), " in ", _react.default.createElement("span", {
        className: "catalogItem"
      }, this.item.catalogItem.title), " was successfully processed.");
    }
  }]);
  return VideoProcessedListItem;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "onSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "asLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
})), _class);
exports.default = VideoProcessedListItem;